module.exports = __webpack_public_path__ + "img/kuwait.3c06184f.svg";